import { colorsForSize, findBurgerprintsVariant, matchBurgerprintsOption } from './burgerprintsFulfill.js';

const COMPOUND_STYLES = ['WomensV-NeckT-Shirt', 'WomenT-Shirt', 'YouthT-Shirt', 'UnisexT-Shirt', 'V-NeckT-Shirt']
  .sort((a, b) => b.length - a.length);

const BARE_TSHIRT_TO_STYLE = {
  Women: 'WomenT-Shirt',
  Woman: 'WomenT-Shirt',
  Unisex: 'UnisexT-Shirt',
  Youth: 'YouthT-Shirt',
};

const DIRECT_PRODUCT = {
  'Women-Gildan-WomenT-Shirt': 'G5000L',
  'Unisex-Gildan-Sweatshirt': 'G18000',
  'Unisex-Gildan-Hoodie': 'G18500',
  'Unisex-BellaCanvas-UnisexT-Shirt': 'BC3001',
  'Unisex-Gildan-UnisexT-Shirt': 'G5000',
  'Unisex-ComfortColor-UnisexT-Shirt': 'CC1717',
  'Unisex-Gildan-TankTop': 'G5200',
};

const COLOR_ALIAS = {
  ashgrey: 'Ash',
  ashgray: 'Ash',
  'ash grey': 'Ash',
  'ash gray': 'Ash',
  sportgrey: 'Sport Grey',
  sportgray: 'Sport Grey',
  'sport grey': 'Sport Grey',
  'sport gray': 'Sport Grey',
  royalblue: 'Royal',
  'royal blue': 'Royal',
  navyblue: 'Navy',
  'navy blue': 'Navy',
};

const SIZE_ALIAS = {
  xxl: '2XL',
  xxxl: '3XL',
  xxxxl: '4XL',
  xxxxxl: '5XL',
  '2x': '2XL',
  '3x': '3XL',
  '4x': '4XL',
  '5x': '5XL',
};

function norm(value) {
  return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

function normalizeToken(value) {
  return String(value || '')
    .replace(/ComfortColors/g, 'ComfortColor')
    .replace(/Bella\+Canvas/g, 'BellaCanvas');
}

export function parseMerchfoxOrder(orderItem) {
  const rawSize = String(orderItem?.size || '');
  const orderColor = String(orderItem?.color || '').trim();
  if (rawSize.includes('Size: US')) {
    return { skuKey: 'Crocs', orderSize: '', orderColor, sizeArray: [], crocs: true };
  }

  let size = rawSize
    .replace(/\*/g, '')
    .replace('Type: ', '')
    .replace('Fabric Brand: ', '')
    .replace('Style: ', '')
    .replace('Size: ', '')
    .replace(/'/g, '')
    .replace('Product Sides Options: ', '')
    .replace('Product Sides: ', '')
    .replace(/ /g, '');

  const placeholders = {};
  let index = 0;
  COMPOUND_STYLES.forEach((style) => {
    const escaped = style.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    size = size.replace(new RegExp(escaped, 'g'), () => {
      const token = `__ST${index}__`;
      placeholders[token] = style;
      index += 1;
      return token;
    });
  });
  size = size.replace(/T-Shirt/g, 'TShirt');
  const sizeArray = size.split('-').map((part) => normalizeToken(placeholders[part] || part));
  if (sizeArray[2] === 'TShirt' && BARE_TSHIRT_TO_STYLE[sizeArray[0]]) {
    sizeArray[2] = BARE_TSHIRT_TO_STYLE[sizeArray[0]];
  }
  return {
    skuKey: [sizeArray[0], sizeArray[1], sizeArray[2]].filter(Boolean).join('-'),
    orderSize: sizeArray[3] || '',
    orderColor,
    sizeArray,
    crocs: false,
  };
}

function detectFromParts(sizeArray = []) {
  const typeU = String(sizeArray[0] || '').toUpperCase();
  const brandU = String(sizeArray[1] || '').toUpperCase();
  const styleU = String(sizeArray[2] || '').toUpperCase();
  if (!styleU) return '';
  const isTee = /TSHIRT|T-SHIRT/.test(styleU);
  const isWomen = /WOMEN|WOMAN/.test(typeU) || /WOMEN/.test(styleU);
  const isYouth = /YOUTH/.test(typeU) || /YOUTH/.test(styleU);
  const isHoodie = /HOODIE/.test(styleU);
  const isSweat = /SWEAT/.test(styleU);
  const isTank = /TANK/.test(styleU);
  const isVneck = /V-?NECK/.test(styleU);
  const isBella = /BELLA/.test(brandU);
  const isComfort = /COMFORT/.test(brandU);

  if (isHoodie && isYouth) return 'G18500B';
  if (isHoodie) return 'G18500';
  if (isSweat && isYouth) return 'G18000B';
  if (isSweat) return 'G18000';
  if (isTank && isComfort) return 'CC9360';
  if (isTank && isBella) return 'BC3480';
  if (isTank) return 'G5200';
  if (isVneck && isWomen) return 'G5V00L';
  if (isVneck && isBella) return 'BC3005';
  if (isVneck) return 'G64V00DTG';
  if (isYouth && isTee && isComfort) return 'CC9018';
  if (isYouth && isTee && isBella) return 'BC3001Y';
  if (isYouth && isTee) return 'G5000B';
  if (isWomen && isTee) return 'G5000L';
  if (isComfort && isTee) return 'CC1717';
  if (isBella && isTee) return 'BC3001';
  if (isTee && brandU) return 'G5000';
  return '';
}

export function detectA2kProductCode(orderItem) {
  const parsed = parseMerchfoxOrder(orderItem);
  if (parsed.crocs) {
    return {
      productCode: '',
      requireManual: true,
      reason: 'A2K không có Crocs — chọn catalog thủ công',
      parsed,
    };
  }
  const productCode = DIRECT_PRODUCT[parsed.skuKey] || detectFromParts(parsed.sizeArray);
  if (productCode) return { productCode, requireManual: false, parsed };
  return {
    productCode: '',
    requireManual: true,
    reason: 'A2K chưa auto-match được loại sản phẩm, vui lòng chọn catalog thủ công',
    parsed,
  };
}

export function matchA2kSize(wanted, values = []) {
  const alias = SIZE_ALIAS[norm(wanted)];
  if (alias) {
    const hit = matchBurgerprintsOption(alias, values);
    if (hit) return hit;
  }
  return matchBurgerprintsOption(wanted, values);
}

export function matchA2kColor(wanted, values = []) {
  const alias = COLOR_ALIAS[norm(wanted)];
  if (alias) {
    const hit = matchBurgerprintsOption(alias, values);
    if (hit) return hit;
  }
  return matchBurgerprintsOption(wanted, values);
}

export function matchA2kVariant(detail, orderItem) {
  const parsed = parseMerchfoxOrder(orderItem);
  const variants = detail?.variants || [];
  const size = matchA2kSize(parsed.orderSize, detail?.sizes || []);
  const colors = colorsForSize(variants, size);
  const color = matchA2kColor(parsed.orderColor, colors) || (colors.length === 1 ? colors[0] : '');
  const variant = findBurgerprintsVariant(variants, size, color);
  return {
    ...parsed,
    size,
    color,
    sku: variant?.sku || '',
    price: variant?.price || '',
    matched: !!variant?.sku,
  };
}
